import Sliders from "./Sliders";

export default class InfinityLoader {
	constructor() {
		this.container = document.getElementById("infinity-loader");

		if (this.container) {
			this.loading = document.getElementById("loading");
			this.loadmore = document.getElementById("load-more");
			this.data = new FormData();
			this.page = 1;

			if ("IntersectionObserver" in window) {
				this.observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) {
								this.init();
							}
						});
					},
					{
						threshold: 1,
					}
				);

				if (this.loading) {
					this.observer.observe(this.loading);
				}
			}

			if (this.loadmore) {
				this.loadmore.addEventListener("click", this.init.bind(this));
			}
		}
	}

	init() {
		this.setData();
		this.fetchData();
	}

	setData() {
		this.data.append("action", "infinity_loader");
		this.data.append("page", ++this.page);
		this.data.append("type", this.container.dataset.type);
		this.data.append("query", this.container.dataset.query);
	}

	fetchData() {
		fetch(EHTScripts.url.ajax, {
			body: this.data,
			credentials: "same-origin",
			headers: {
				Accept: "application/json",
			},
			method: "POST",
		})
			.then((resp) => {
				return resp.json();
			})
			.then((resp) => {
				if (resp.length == 0) {
					if (this.container.dataset.type == "product") {
						let noMore = document.createElement("div");
						noMore.classList.add("p-5");
						noMore.classList.add("text-center");
						noMore.textContent = "No more products found!";
						this.container.after(noMore);
					}

					if (this.loading) {
						this.observer.unobserve(this.loading);
						this.loading.remove();
					}

					if (this.loadmore) {
						this.loadmore.remove();
					}
				} else {
					this.container.innerHTML += resp;

					if (this.loading) {
						this.observer.unobserve(this.loading);
						this.observer.observe(this.loading);
					}

					if (this.container.dataset.type == "product") {
						new Sliders();
					}
				}
			})
			.catch((error) => console.log(error));
	}
}
